<template>
  <el-dialog
    class="public-preview-dialog"
    title="预览"
    :visible.sync="dialogShow"
    width="1400px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleClose"
    top="0"
  >
    <div class="trainDetail">
      <div class="center">
        <!-- <h1>{{ form.name }}</h1> -->
        <div v-html="form.name" style="text-align: center"></div>
        <div class="content trainDetail-content" v-html="form.content"></div>
        <div class="junct" id="junct-id" v-if="form.adjunctUrl.length > 0">
          <div class="title">附件:</div>
          <p v-for="(item, i) in form.adjunctUrl" :key="i">
            <a class="item" target="_blant" :href="item.url">{{ item.name }}</a>
          </p>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'TrainDetail',
  props: ['form'],
  data() {
    return {
      dialogShow: true
    }
  },
  methods: {
    handleClose() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.trainDetail {
  .fr {
    float: right;
  }
  .clear {
    clear: both;
  }
  .center {
    width: 1200px;
    margin: 0 auto;
    margin-top: 30px;
    // padding: 0 36px;
    box-sizing: border-box;
    margin-bottom: 50px;
    background-color: #fff;
    padding-bottom: 108px;
    h1 {
      max-width: 800px;
      font-size: 36px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #0853b6;
      text-align: center;
      margin: 20px auto 60px;
    }
    .pors {
      margin-bottom: 55px;
      padding-right: 88px;
      .fr {
        cursor: pointer;
        img,
        span {
          vertical-align: middle;
        }
        img {
          width: 24px;
          height: 24px;
        }
        span {
          font-size: 14px;
          color: #0854b6;
          font-weight: bold;
        }
      }
    }
    .content {
      margin: 0 80px;
      margin-bottom: 50px;
    }
    .junct {
      margin: 0 80px;
      margin-bottom: 80px;
      .title {
        text-decoration: underline;
        font-weight: 700;
      }
      p {
        margin: 10px 0;
        text-decoration: underline;
      }
    }
  }

  .btn {
    width: 200px;
    height: 50px;
    border-radius: 25px;
    margin: 40px auto;
    display: block;
    color: #fff;
    font-size: 24px;
    background: linear-gradient(90deg, #0f59be 0%, #496eee 100%);
    box-shadow: 0px 1px 13px 0px rgba(0, 0, 0, 0.08);
  }
}
</style>
